import { css } from '@emotion/react'
import { Skeleton } from '@mui/material'
import { useTranslation } from 'next-i18next'
import Image from 'components/Image/Image'

interface Props {
  onMouseDown: () => void
  staticMapUrl: string | undefined
}

export const StaticMapDisplay = ({ onMouseDown, staticMapUrl }: Props) => {
  const { t } = useTranslation('common')
  return (
    <>
      {staticMapUrl && (
        <Image
          alt={t('map.alt_text')}
          src={staticMapUrl}
          fill
          unoptimized
          priority
          fetchPriority="high"
          onMouseDown={onMouseDown}
          css={css`
            object-fit: cover;
          `}
        />
      )}
      {!staticMapUrl && (
        <Skeleton
          sx={{ height: '100%', width: '100%' }}
          variant="rectangular"
        />
      )}
    </>
  )
}
